import React from 'react';
import { FormattedMessage } from 'react-intl';

import FocusableHeader from 'components/focusableheader/FocusableHeader';
import { AppRoutes } from 'routes';

import Link from '../../components/link/Link';

const LandingPage = () => (
    <div className="grey-banner">
        <div className="landing-page">
            <FocusableHeader>
                <FormattedMessage id="landing.page.header" />
            </FocusableHeader>
            <hr className="fs-bar orange" />
            <p>
                <FormattedMessage id="landing.page.subheader" />
            </p>
            <hr className="fs-grey-bar-arrow" />
            <h4>
                <FormattedMessage id="landing.page.new.account.title" />
            </h4>
            <p>
                <FormattedMessage id="landing.page.new.account.text" />
            </p>
            <Link className="landing-page-link" to={AppRoutes.registrationPage}>
                <FormattedMessage id="landing.page.new.account.link" />
            </Link>
            <h4>
                <FormattedMessage id="landing.page.existing.account.title" />
            </h4>
            <p>
                <FormattedMessage id="landing.page.existing.account.text" />
            </p>
            <Link className="landing-page-link" to={AppRoutes.loginPage}>
                <FormattedMessage id="landing.page.existing.account.link" />
            </Link>
        </div>
    </div>
);

export default LandingPage;
